import { useNavigate } from 'react-router-dom';
import { useHasPermission } from '@/hooks/use-has-permission';
import { HRM_PERMISSIONS } from '@/constant/hr/permissions';
import { ServiceDeskPageShell } from '@/modules/service-desk/shared/components/service-desk-page-shell';
import { NocMyApplications } from '../../components/noc-my-applications/noc-my-applications';
import { NocRequests } from '../../components/noc-requests/noc-requests';

export const NocPage = () => {
  const navigate = useNavigate();
  const canViewRequests = useHasPermission(HRM_PERMISSIONS.NOC_APPLICATION.VIEW_REQUESTS);
  const canApply = useHasPermission(HRM_PERMISSIONS.NOC_APPLICATION.APPLY);

  return (
    <ServiceDeskPageShell
      titleKey="NOC_TITLE"
      requestsTabKey="NOC_REQUESTS"
      canViewRequests={canViewRequests}
      requests={<NocRequests />}
      mine={<NocMyApplications />}
      onApply={canApply ? () => navigate('/hr/service-desk/noc/apply') : undefined}
    />
  );
};
